document.addEventListener("DOMContentLoaded", () => {
  // async function refreshCartDrawer() {
  //   // 👈 fetch the drawer HTML
  //   const res = await fetch("/cart?view=drawer");
  //   const html = await res.text();

  //   const drawer = document.querySelector(
  //     "#HeaderCart .site-header__drawer-animate"
  //   );

  //   if (drawer) drawer.innerHTML = html;

  //   openCartDrawer();
  // }

  // function openCartDrawer() {
  //   document.body.classList.add("js-drawer-open", "cart-drawer-open");

  //   const drawer = document.querySelector("#HeaderCart");
  //   if (drawer) drawer.classList.add("is-open", "open", "is-active");
  // }

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".upsell-add");
    if (!btn) return;

    try {
      const resupsell = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: btn.dataset.variantId,
          quantity: 1,
        }),
      });

      const dataUpsell = await resupsell.json();

      if (!resupsell.ok || dataUpsell.status === 422) {
        throw new Error(dataUpsell?.message || "Unable to add to cart");
      }

      document.dispatchEvent(
        new CustomEvent("ajaxProduct:added", { detail: dataUpsell })
      );

      // await refreshCartDrawer();
    } catch (err) {
      console.error(err);
    }
  });
});
